<template>
  <div>
    <slot />
    <!-- <div
      class="error-isolation-scope-container--error-display-container"
      v-if="hasError && !closed"
    >
      <div class="error-isolation-scope-container--error-display-container-inner">
        Error: {{ error.message }} {{ errorVm }}
        <button
          class="error-isolation-scope-container--error-display-container-close-button"
          @click.prevent.stop="() => (closed = true)"
        >
          x
        </button>
      </div>
    </div> -->
  </div>
</template>

<script>
/**
 * # ErrorIsolationScopeContainer: エラースコープ隔離 用 コンポーネント (※ 省略名 <ErrorContainer> )
 *
 * - 背景・役割: 例えば、 特定の router (ページ) 内の 1つのコンポーネントのエラーが波及して アプリケーション全体の挙動が停止してしまう事があるが、それを防ぐためのコンポーネント
 * - エラーが発生した場合に、エラーを隔離して表示する事が可能
 *
 * ## Usage
 *
 * ```vue
 * <ErrorIsolationScopeContainer>
 *   <!-- この中で発生したエラーは この slot 内 にのみ波及 -->
 *   <YourComponent />
 * </ErrorIsolationScopeContainer>
 * <!-- コンポーネントの外側には エラーは影響しない -->
 * ```
 */
export default {
  name: 'ErrorIsolationScopeContainer',

  props: {
    fallback: {
      type: [Object, Function],
      default: null,
    },
    onError: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      error: null,
      errorInfo: null,
      hasError: false,
      retryAttempts: 0,
      componentStack: null,
      closed: false,
    }
  },

  // mounted() {
  //   console.log('[ErrorIsolationScopeContainer] mounted')
  //   window.addEventListener('error', this.handleGlobalError)
  //   window.addEventListener('unhandledrejection', this.handleUnhandledRejection)
  // },

  // unmounted() {
  //   console.log('[ErrorIsolationScopeContainer] unmounted')
  //   window.removeEventListener('error', this.handleGlobalError)
  //   window.removeEventListener('unhandledrejection', this.handleUnhandledRejection)
  // },

  // errorCaptured(err, vm, info) {
  //   return this.handleError(err, vm, info)
  // },

  methods: {
    handleError(error, component, info) {
      this.closed = false
      this.error = error
      this.errorInfo = info
      this.hasError = true
      this.componentStack = component ? this.generateComponentStack(component) : null

      // エラーログの記録
      this.logError(error, info)

      // 親コンポーネントへの通知
      if (this.onError) {
        this.onError(error, component, info)
      }

      return false // エラーの伝播を停止
    },

    generateComponentStack(component) {
      const stack = []
      let currentComponent = component

      while (currentComponent) {
        stack.push(currentComponent.$options.name || 'AnonymousComponent')
        currentComponent = currentComponent.$parent
      }

      return stack.join(' > ')
    },

    logError(error, info) {
      console.error('[ErrorBoundary]', {
        error,
        info,
        componentStack: this.componentStack,
        timestamp: new Date().toISOString(),
      })
      // $core.$errorReporter.r(error, info, this.componentStack)
    },

    reset() {
      this.error = null
      this.hasError = false
      this.retryAttempts = 0
      this.componentStack = null
    },

    handleGlobalError(event) {
      if (!this.hasError) {
        this.handleError(event.error, null, 'window.onerror')
        event.preventDefault()
      }
    },

    handleUnhandledRejection(event) {
      if (!this.hasError) {
        this.handleError(event.reason, null, 'unhandledrejection')
        event.preventDefault()
      }
    },
  },
}
</script>

<style lang="scss">
.error-boundary-fallback {
  // padding: 20px;
  // border: 1px solid #f56c6c;
  // border-radius: 4px;
  // background-color: #fef0f0;
}

.component-stack {
  font-family: monospace;
  font-size: 0.9em;
  color: #666;
}
// fixed 最下部 表示, 100% 幅
.error-isolation-scope-container--error-display-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1060;
  background-color: rgba(251, 228, 228, 0.5);
  &:hover {
    background-color: rgba(251, 228, 228, 1);
  }
  color: #681e1e;
  padding: 1px;
  border-top: 1px solid var(--bs-danger);
  border-radius: 0;
  text-align: center;
}
</style>
